import { Phone } from "lucide-react";
import { scrollToId } from "../lib/scroll";
import { PHONE_TEL } from "../lib/site";

export const StickyCTA = () => (
  <div
    data-testid="sticky-mobile-cta"
    className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t-2 border-lec-ink bg-white md:hidden"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
  >
    <a
      href={PHONE_TEL}
      data-testid="sticky-call-button"
      className="flex items-center justify-center gap-2 py-4 text-sm font-bold uppercase tracking-wider text-lec-ink active:bg-lec-alt"
    >
      <Phone className="h-4 w-4" strokeWidth={2.5} />
      Call Damien
    </a>
    <button
      data-testid="sticky-quote-button"
      onClick={() => scrollToId("#quote")}
      className="bg-lec-green py-4 text-sm font-bold uppercase tracking-wider text-lec-ink active:bg-lec-green/80"
    >
      Request a Quote
    </button>
  </div>
);
